import { compose, prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getCommunicationGroups = compose(prop('communicationGroups'), getRoot);
export const getQuickFilterState = compose(prop('quickFilter'), getRoot);
export const getSelectedGroupId = compose(prop('selectedGroup'), getRoot);
export const getSort = compose(prop('sort'), getRoot);

export const getSelectedGroup = createSelector(getCommunicationGroups, getSelectedGroupId, (groups, selectedId) =>
	groups.find((group) => group.id === selectedId),
);
